export enum TestIds {
  // All Screens
  BACK_BUTTON = 'BACK_BUTTON',
  SEARCH_BUTTON = 'SEARCH_BUTTON',
  CANCEL_BUTTON = 'CANCEL_BUTTON',

  // Product Results Screen
  EDIT_FILTER_COLOR_BUTTON = 'EDIT_FILTER_COLOR_BUTTON',
  EDIT_FILTER_BUTTON = 'EDIT_FILTER_BUTTON',

  // Variation Details Screen
  VIEW_ALL_COLORS_BUTTON = 'VIEW_ALL_COLORS_BUTTON',
  HIDE_COLORS_BUTTON = 'HIDE_COLORS_BUTTON',
  APPLY_VARIATION_BUTTON = 'APPLY_VARIATION_BUTTON',

  // Filter Screen
  ACCORDION_TYPE_BUTTON = 'ACCORDION_TYPE_BUTTON',
  ACCORDION_TYPE_CONTENT = 'ACCORDION_TYPE_CONTENT',

  ACCORDION_COLOR_BUTTON = 'ACCORDION_COLOR_BUTTON',
  ACCORDION_COLOR_CONTENT = 'ACCORDION_COLOR_CONTENT',

  ACCORDION_BRAND_BUTTON = 'ACCORDION_BRAND_BUTTON',
  ACCORDION_BRAND_CONTENT = 'ACCORDION_BRAND_CONTENT',

  ACCORDION_STYLE_BUTTON = 'ACCORDION_STYLE_BUTTON',
  ACCORDION_STYLE_CONTENT = 'ACCORDION_STYLE_CONTENT',

  ACCORDION_TEXTURE_BUTTON = 'ACCORDION_TEXTURE_BUTTON',
  ACCORDION_TEXTURE_CONTENT = 'ACCORDION_TEXTURE_CONTENT',

  ACCORDION_SIZE_BUTTON = 'ACCORDION_SIZE_BUTTON',
  ACCORDION_SIZE_CONTENT = 'ACCORDION_SIZE_CONTENT',

  APPLY_FILTER = 'ACCORDION_APPLY_FILTER',
}

export enum TestPageIds {
  PRODUCT_RESULTS = 'PRODUCT_RESULTS',
  PRODUCT_RESULTS_ONE_MANUFACTURER = 'PRODUCT_RESULTS_ONE_MANUFACTURER',
  FILTER = 'FILTER',
  VARIATION_DETAILS = 'VARIATION_DETAILS',
  SEARCH = 'SEARCH',

  SHOW_WALL_GROUPS = 'SHOW_WALL_GROUPS',
}

export enum TestLabels {
  // Wall Menu
  WALL_GROUP_EDIT = 'WALL_GROUP_EDIT',
  WALL_GROUP_VARIATION_EDIT = 'WALL_GROUP_VARIATION_EDIT',
  WALL_GROUP_VARIATION_DETAILS = 'WALL_GROUP_VARIATION_DETAILS',

  // Product Results Screen
  BRAND_GROUP = 'BRAND_GROUP',
  VIEW_ALL_VARIATIONS = 'VIEW_ALL_VARIATIONS',
  VARIATION_THUMBNAIL = 'VARIATION_THUMBNAIL',
  VARIATION_THUMBNAIL_APPLY = 'VARIATION_THUMBNAIL_APPLY',
  VARIATION_THUMBNAIL_DETAILS = 'VARIATION_THUMBNAIL_DETAILS',

  // Filter Option
  FILTER_PRODUCT_OPTION = 'FILTER_PRODUCT_OPTION',
  FILTER_COLOR_OPTION = 'FILTER_COLOR_OPTION',
  FILTER_BRAND_OPTION = 'FILTER_BRAND_OPTION',
  FILTER_STYLE_OPTION = 'FILTER_STYLE_OPTION',
  FILTER_TEXTURE_OPTION = 'FILTER_TEXTURE_OPTION',
  FILTER_SIZE_OPTION = 'FILTER_SIZE_OPTION',
}
